import React from 'react'
import { connect } from 'react-redux'
// Local
import { condition as conditionUtils } from '../../common/conditionUtils'
import { encounterPractitionerTagsEnabled } from '../../common/currentUserUtils'
import { formatConditionTitleExt } from '../../common/formatUtils'
import AddressedIcon from '../common/addressedIcon'
import ConditionDismissed from '../common/conditionDismissed'
import PhysicianConditionHeaderToolbar from './physicianConditionHeaderToolbar'
import If from '../../common/if'
import { EncounterConditionDisplay } from '../../authenticated/types'
import { shouldRenderReskin2025 } from '../../../constant'
import { RootState } from '../../../store'

/**
 * Provides a component for the physician condition header title. The title
 * can include a toolbar and condition properties
 *
 * @param mode View mode. Options: null or "smart". Default: null
 * @param active True if condition is currently in active state
 * @param hccChild True if condition is a member of an HCC display group
 * @param hccAddressed True if condition is a member of an HCC display group
 *        and the group is marked as addressed
 * @param condition Condition entity
 * @param onConditionAction Callback for condition action
 *        Arguments: action, condition
 */

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  active: boolean
  condition: EncounterConditionDisplay
  mode: 'smart' | null
  onConditionAction: (
    action: any,
    condition: EncounterConditionDisplay
  ) => void
  hccChild: boolean
}

function PhysicianConditionHeaderTitle(
  props: Props
) {
  const {
    active: isActive,
    condition: conditionProp,
    currentUser,
    mode,
    onConditionAction,
    hccChild: isHccChild
  } = props
  const titleText = formatConditionTitleExt(
    conditionProp,
    { hccChild: isHccChild }
  )
  const showToolbar = (
    encounterPractitionerTagsEnabled(currentUser) &&
    !isHccChild &&
    !conditionUtils.isConditionAddressed(conditionProp)
  )

  const conditionTitle = shouldRenderReskin2025
    ? 'condition-title reskin'
    : 'condition-title'

  if (mode && mode === 'smart') {
    return (
      <div className="physician-condition-title">
        <div className="flex-title">
          <AddressedIcon condition={ conditionProp } />
          <div className={ conditionTitle }>
            <If isTrue={ isActive }>
              <strong>
                { titleText }
              </strong>
            </If>
            <If isTrue={ !isActive }>
              titleText
            </If>
            <div className="condition-toolbar">
              <ConditionDismissed condition={ conditionProp } />
            </div>
          </div>
        </div>
        <If isTrue={ !!showToolbar }>
          <div className="m-1-top">
            <PhysicianConditionHeaderToolbar
              mode={ mode }
              condition={ conditionProp }
              onConditionAction={
                onConditionAction as unknown as (
                  action: any,
                  conditions: EncounterConditionDisplay[]
                ) => void
              }
            />
          </div>
        </If>
      </div>
    )
  }

  return (
    <div className="physician-condition-title">
      <div className="flex-title">
        <AddressedIcon condition={ conditionProp } />
        <div className={ conditionTitle }>
          <If isTrue={ isActive }>
            <strong>
              { titleText }
            </strong>
          </If>
          <If isTrue={ !isActive }>
            titleText
          </If>
        </div>
        <div className="condition-toolbar">
          <If isTrue={ !showToolbar }>
            <ConditionDismissed condition={ conditionProp } />
          </If>
          <If isTrue={ !!showToolbar }>
            <PhysicianConditionHeaderToolbar
              mode={ mode }
              condition={ conditionProp }
              onConditionAction={ onConditionAction as unknown as (action: any, conditions: EncounterConditionDisplay[]) => void }
            />
          </If>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(PhysicianConditionHeaderTitle)
